import { css, etiColors } from '@eti/styles';
import { ReactComponent as ExitLeft } from '@eti/assets/icons/exit-left.svg';
import { ReactComponent as ExitRight } from '@eti/assets/icons/exit-right.svg';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ArrowDirection = {
  LEFT: 'left',
  RIGHT: 'right'
};
const wrapperStyles = direction => css`
  align-items: center;
  display: flex;
  height: 1.375rem;
  justify-content: center;
  margin-bottom: 0;
  margin-top: 0;
  position: relative;
  width: 2rem;

  svg {
    fill: ${etiColors.critical.solid};
    height: 24px;
    position: absolute;
    width: 24px;
    ${direction}: 0; /* stylelint-disable-line */
  }
`;
const setIcon = direction => direction === ArrowDirection.LEFT ? /*#__PURE__*/_jsx(ExitLeft, {}) : /*#__PURE__*/_jsx(ExitRight, {});
const ExitArrow = _ref => {
  let {
    direction
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: wrapperStyles(direction),
    children: setIcon(direction)
  });
};
ExitArrow.Direction = ArrowDirection;
export default ExitArrow;
//# sourceMappingURL=ExitArrow.js.map